module.exports = __webpack_public_path__ + "img/three.2ddd0936.jpg";